import React, { useState, useEffect } from 'react'
import { useWebAuthentication } from 'webapp/providers/authentication'
import { AuthPageLayout } from '@elements'
import { localizedStrings } from '@core/strings'
import { Card, LinearProgress } from '@common/material'
import { Box, Text } from '@fundamentals'

const HomePage = () => {
  const { isAuthenticated, user, redirectOnLogin } = useWebAuthentication()
  const [currentStep, setCurrentStep] = useState(0)

  const initSteps = [
    localizedStrings.homePageLoadingStep1,
    localizedStrings.homePageLoadingStep2,
    localizedStrings.homePageLoadingStep3,
    localizedStrings.homePageLoadingStep4,
  ]

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentStep((prev) => (prev < initSteps.length - 1 ? prev + 1 : prev))
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  // Redirect to organisation or admin page if authenticated
  useEffect(() => {
    if (isAuthenticated && !!user) {
      redirectOnLogin()
    }
  }, [isAuthenticated, user])

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      minHeight='60vh'
      px={4}
    >
      <Card sx={{ maxWidth: 600, width: '100%', p: 4, textAlign: 'center' }}>
        <Box sx={{ width: '100%' }}>
          <Text variant='body1' sx={{ mb: 3 }}>
            {initSteps[currentStep]}
          </Text>
          <LinearProgress
            variant='determinate'
            value={((currentStep + 1) / initSteps.length) * 100}
            sx={{ mb: 2, height: 8, borderRadius: 4 }}
          />
          <Text variant='body2' color='text.secondary'>
            Step {currentStep + 1} of {initSteps.length}
          </Text>
        </Box>
      </Card>
    </Box>
  )
}

HomePage.getLayout = ({ router, page }) => {
  return <AuthPageLayout page={page} />
}

export default HomePage
